
import React from "react";

export const EventNotFound: React.FC = () => {
  return <div className="container py-8">Event not found</div>;
};
